import { fetchSeguro } from '../../../lib/fetchSeguro';
import type {
    ApiKeyActionResponse,
    ApiKeyCreatePayload,
    ApiKeyCreateResponse,
    ApiKeyListResponse,
} from '../types/apiKey.types';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export class ApiKeyService {
    static listar() {
        return fetchSeguro<ApiKeyListResponse>('/sittApi/api_keys/listar.php', {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
            },
        });
    }

    static crear(payload: ApiKeyCreatePayload) {
        return fetchSeguro<ApiKeyCreateResponse>('/sittApi/api_keys/crear.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: JSON_HEADERS,
            body: JSON.stringify(payload),
        });
    }

    static revocar(claveApiKey: number) {
        return fetchSeguro<ApiKeyActionResponse>('/sittApi/api_keys/revocar.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: JSON_HEADERS,
            body: JSON.stringify({ clave_api_key: claveApiKey }),
        });
    }
}
